import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { getProjectsAsync } from '../../api/projects'

export default function useGlobalSearchListing(pageNumber, query) {
    const [busy, setBusy] = useState(false)
    const [searchData, setSearchData] = useState([])
    const [hasMore, setHasMore] = useState(false)
    const controllerRef = useRef(null)

    const handleFetchData = async () => {
        if (!query) {
            setSearchData([])
            setBusy(false)
            return
        }

        if (controllerRef.current) {
            controllerRef.current.abort()
        }

        controllerRef.current = new AbortController()
        setBusy(true)

        try {
            const response = await getProjectsAsync({
                search: query,
                customer: '',
                branch: '',
                status: '',
                pageNumber: pageNumber,
                filter_start_date: '',
                filter_end_date: '',
                signal: controllerRef.current.signal,
            })

            if (pageNumber === 1) {
                setSearchData(response?.data?.data || [])
            } else {
                setSearchData(c => [...c, ...(response?.data?.data || [])])
            }
            setHasMore(response?.data?.hasMore || false)
        } catch (e) {
            if (!axios.isCancel(e)) {
                console.error(e)
            }
        } finally {
            setBusy(false)
        }
    }

    const handleFetch = () => {
        setSearchData([])
        handleFetchData()
    }


    useEffect(() => {
        if (!query) {
            setSearchData([])
            setBusy(false)
            return
        }

        const timer = setTimeout(() => {
            handleFetchData()
        }, 300)

        return () => {
            clearTimeout(timer)
            if (controllerRef.current) {
                controllerRef.current.abort()
            }
        }
    }, [query])

    useEffect(() => {
        if (pageNumber > 1 && query) { handleFetchData() }
        return () => {
            if (controllerRef.current) { controllerRef.current.abort() }
        }
    }, [pageNumber])

    return { busy, setBusy, searchData, hasMore, handleFetch, setSearchData }
}